import ProgressVerificationModal from './ProgressVerificationModal'

export default ProgressVerificationModal;